
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { NextPage } from 'next';
import get from 'lodash/get';
import { PageProps } from 'types/pages';
import { mapNextLocaleToISOLanguageCode } from 'helpers/locale.helper';
import { mapObjectToQueryString } from 'helpers/url';
import { getDocumentRelationsFromFile } from 'prismic/getDocumentRelations';
import { fetchDocumentContent } from 'prismic/helpers/fetchContent';
import { fetchCourses } from 'prismic/api/courses';
import { DomainType } from 'prismic/config';
import TemplateWrapper from 'components/templates/partials/TemplateWrapper';
import { OverviewKurse } from 'components/organisms/OverviewKurse';
import Header from 'components/organisms/Header/Header';
import { Footer } from 'components/organisms/Footer';
import { HeaderSpacer } from 'components/atoms/HeaderSpacer';

const Kurse: NextPage<any> = ({ header, data, footer, sharedSlices, courses }) => {
  const { alternate_languages } = data;

  return (
    <TemplateWrapper pageId={data.id} data={data}>
      <Header {...header} alternateLanguages={alternate_languages} />
      <HeaderSpacer />
      <OverviewKurse data={data} courses={courses} sharedSlices={sharedSlices} />
      <Footer data={get(footer, 'data.body', [])} />
    </TemplateWrapper>
  );
};

 async function _getServerSideProps({ params, locale, query }: any) {
  const { domain } = params;

  const isoLangCode = mapNextLocaleToISOLanguageCode(locale);

  const documentRelations = await getDocumentRelationsFromFile();

  // Get page data

  const fetchedContent = await fetchDocumentContent({
    lang: isoLangCode,
    domain: domain as DomainType,
    isValidPath: true,
    uid: 'kurse',
    pageType: 'page',
  });

  const fetchedSharedContent = await fetchDocumentContent({
    lang: isoLangCode,
    domain: domain as DomainType,
    isValidPath: true,
    uid: 'kurs-details-shared-slices',
    pageType: 'page',
  });

  const queryString = mapObjectToQueryString(query);
  const coursesResponse = await fetchCourses({ domain, query: queryString });

  if (!fetchedContent?.data) {
    console.error(`No content found ->`, {
      lang: isoLangCode,
      domain: domain as DomainType,
      isValidPath: true,
      uid: 'kurse',
      pageType: 'page',
    });

    return {
      notFound: true,
    };
  }

  const { data, header, footer, type } = fetchedContent;

  return {
    props: {
      type,
      header,
      footer,
      data,
      sharedSlices: fetchedSharedContent ? fetchedSharedContent.data : {},
      courses: coursesResponse ? coursesResponse.data : {},
      documentRelations,
      sharedData: null,
      domain: domain as DomainType,
    } as PageProps,
  };
}

export default Kurse;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/[domain]/kurse/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  